import { Injectable } from '@angular/core';
import { Store } from '../storage/store';

@Injectable({providedIn: 'root'})
export class BaseService {
  protected store = new Store();

  dispose(): void {
    this.store.dispose();
  }
}
